import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ButtonPrimary, ButtonSpan } from "Components/Button";
import Modal from "Components/Modal";
import { companyUnload, fetchCountries } from "../../redux/actions";
import { token } from "../../modules/auth";
import {
  email as emailValidator,
  emailSeperated,
} from "../../modules/validation";
import { Input, Textarea, Toggle } from "../../Components/Form";
import { Field, reduxForm, change } from "redux-form";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Succeeded from "../Form/Succeeded";
import Loading from "../Loading";
const mapStateToProps = state => ({
  token: token(state),
});

const form = "share-for-feedback";
const mapDispatchToProps = {
  setNote: note => change(form, "note", note),
};
const Wrapper = ({ children, onClose }) => (
  <Modal>
    <div className="modal">
      <div
        className="modal-inner"
        style={{
          width: 600,
          maxWidth: "90%",
        }}
      >
        <ButtonSpan className="m-3 absolute pin-t pin-r z-10" onClick={onClose}>
          <i className="fas fa-times-circle fa-2x ml-3" />
        </ButtonSpan>
        {children}
      </div>
    </div>
  </Modal>
);

const ShareVenuesForFeedbackModal = props => {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    props.setNote(
      (props.venuesText || []).map(venue => `- ${venue}`).join("\n")
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let onSubmit = async values => {
    try {
      setLoading(true);
      await axios
        .post(
          `${window.API}/share-venues-for-feedback`,
          { ...values, venues: props.venues, venues_text: props.venuesText },
          {
            headers: {
              Authorization: `Bearer ${props.token}`,
            },
          }
        )
        .then(() => {
          setSuccess(true);
          setLoading(false);
          setTimeout(() => {
            props.onClose();
            setSuccess(false);
            //  window.location.href = "/admin/commercial-deals";
          }, 1000);
        });
    } catch (e) {}
  };

  return (
    <Wrapper onClose={props.onClose}>
      <h1 className="mb-8">Share venues</h1>
      <form onSubmit={props.handleSubmit(onSubmit)}>
        <Field
          name="email"
          type="email"
          label="Email address"
          component={Input}
          validate={[emailSeperated]}
        />
        <Field
          name="note"
          type="email"
          label="Note"
          component={Textarea}
          subTextHint={
            "Include any information for the recipient that you want to include in the email we send"
          }
          rows={8}
        />
        <div className={"flex justify-end"}>
          {!loading ? (
            <ButtonPrimary
              classes={`px-6 py-2 flex items-center`}
              style={{ height: "auto" }}
              submit={true}
            >
              Share
            </ButtonPrimary>
          ) : (
            <Loading />
          )}
        </div>
        {success ? (
          <Succeeded className="mt-3" text={" Feedback requested"}></Succeeded>
        ) : null}
      </form>
    </Wrapper>
  );
};
export default withRouter(
  reduxForm({
    form,
  })(connect(mapStateToProps, mapDispatchToProps)(ShareVenuesForFeedbackModal))
);
